@let m = meeting();

<header class="head">
  <div class="head__titles">
    <!-- Card 3803: título exibido, lápis de renomear, descrição curta e título original. -->
    <app-meeting-title-editor
      [meeting]="m"
      [canEdit]="podeAgir() && !!m.visibility?.canManage"
      (renamed)="meetingUpdated.emit($event)" />

    <div class="head__meta">
      @if (avatares().length) {
        <span class="head__avatars" [title]="nomesDasPessoas()">
          @for (pessoa of avatares(); track $index) {
            <span class="head__avatar" role="img" [attr.aria-label]="pessoa.nome">{{
              pessoa.iniciais
            }}</span>
          }
          @if (avataresOcultos()) {
            <span class="head__avatar head__avatar--more">+{{ avataresOcultos() }}</span>
          }
        </span>
      }
      <span class="head__fact">
        <i class="pi pi-calendar" aria-hidden="true"></i>
        {{ m.scheduledStartAt | vaultDateTime }}
      </span>
      @if (m.durationSeconds != null) {
        <span class="head__fact">
          <i class="pi pi-clock" aria-hidden="true"></i>
          {{ duracao(m.durationSeconds) }}
        </span>
      }
      @if (agendas(); as donos) {
        <!-- Card 3191: o organizador nem sempre é dono da agenda que trouxe a reunião. -->
        <span class="head__fact head__fact--calendar" [title]="'Na agenda de ' + donos">
          <i class="pi pi-user" aria-hidden="true"></i> Na agenda de {{ donos }}
        </span>
      }
      <span class="head__divider" aria-hidden="true"></span>
      <app-meeting-status-tag [status]="m.status" />
      @if (m.archivedAt) {
        <!-- Card 3786: arquivada sai das listas e da Home; Restaurar fica no menu "…". -->
        <span
          class="head__access head__access--archived"
          [title]="
            'Arquivada em ' +
            (m.archivedAt | vaultDateTime) +
            '. Use Restaurar no menu … para trazê-la de volta às listas.'
          ">
          <i class="pi pi-inbox" aria-hidden="true"></i> Arquivada
        </span>
      }
      @if (m.sharedWithMe) {
        <span
          class="head__access head__access--shared"
          title="Alguém que participou compartilhou esta meeting com você">
          <i class="pi pi-share-alt" aria-hidden="true"></i> Compartilhada com você
        </span>
      }
      @if (m.hasOtherRecorder) {
        <span
          class="head__access head__access--recorder"
          title="Um gravador de reunião (Fireflies, Otter...) entrou na call. Veja a linha do tempo na aba Detalhes.">
          <i class="pi pi-microphone" aria-hidden="true"></i> Outro gravador na call
        </span>
      }
      @if (tipoDaCall(); as tipo) {
        <span
          class="head__access head__access--type"
          title="Tipo da reunião, classificado pelo Cog">
          <i class="pi pi-sparkles" aria-hidden="true"></i> {{ tipo }}
        </span>
      }
      @if (sealItems().length) {
        <!--
          Card 3803 (opção C): o selo "Visível para" substitui os antigos "Acesso geral", "Time Legatus"
          e "Privada". Abre a janela "Visibilidade da call"; o acesso geral segue na janela Compartilhar.
        -->
        <button
          type="button"
          class="head__seal"
          [title]="sealTooltip()"
          aria-haspopup="dialog"
          (click)="openVisibility.emit()">
          <span class="head__seal-label">
            @if (m.visibility?.isPrivate) {
              <i class="pi pi-lock" aria-hidden="true"></i> Privada ·
            }
            Visível para
          </span>
          @for (item of sealItems(); track item.label) {
            <span
              class="head__seal-item"
              [class.head__seal-item--off]="!item.visible"
              [class.head__seal-item--private]="!item.visible && !!m.visibility?.isPrivate">
              <i [class]="item.icon" aria-hidden="true"></i>
              {{ item.label }}
            </span>
          }
          <i class="pi pi-chevron-down head__seal-caret" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>

  <div class="head__actions">
    @if (m.meetingUrl && aindaNaoAconteceu()) {
      <a class="head__join" [href]="m.meetingUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-external-link" aria-hidden="true"></i> Entrar na call
      </a>
    }
    @if (podeAgir() && m.canShare) {
      <app-button
        [label]="'Compartilhar'"
        [icon]="'pi pi-share-alt'"
        [theme]="'outline-grey'"
        [type]="'button'"
        [disabled]="ocupada()"
        (sendButtonClick)="compartilhar.emit()" />
    }
    <!-- Quem pode compartilhar gere o acesso geral dentro da janela Compartilhar (card 3241). -->
    @if (podeAgir() && m.canManageAccess && !m.canShare) {
      <app-button
        [label]="m.isShared ? 'Voltar a privada' : 'Compartilhar com o time'"
        [icon]="m.isShared ? 'pi pi-lock' : 'pi pi-globe'"
        [theme]="'outline-grey'"
        [type]="'button'"
        [disabled]="ocupada()"
        (sendButtonClick)="alternarAcesso.emit()" />
    }
    @if (m.hasRecording) {
      <app-button
        [label]="'Baixar vídeo'"
        [icon]="'pi pi-download'"
        [type]="'button'"
        [isLoading]="baixando()"
        (sendButtonClick)="baixar.emit()" />
    }
    @if (acoesDoMenu().length) {
      <div class="head__menu">
        <app-action-menu [items]="acoesDoMenu()" />
      </div>
    }
  </div>
</header>
